import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IMinisiteSchemaPartial } from '../../type/minisite';

export interface ICreateMinisiteMutationFields {
  status: boolean;
  redirectToHttps: boolean;
  companyId: string;
  domains: string[]
  seoKeywords?: string[]
}


export interface ICreateMinisiteMutationResponseFields {
  createdMinisite: IMinisiteSchemaPartial;
}



export function createMinisiteMutation(fragment: string): DocumentNode {
  return gql`
        mutation createMinisite (
        $status: Boolean!,
$redirectToHttps: Boolean!,
$companyId: String!,
$domains: [String]!,
$seoKeywords: [String]
        ) {
        createMinisite (
        status: $status,
redirectToHttps: $redirectToHttps,
companyId: $companyId,
domains: $domains,
seoKeywords: $seoKeywords
        ) {
        ...fragment
        }
        }
        fragment fragment on CreateMinisiteMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useCreateMinisiteMutation<TData extends Partial<ICreateMinisiteMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ createMinisite: TData },
        ICreateMinisiteMutationFields>,
) {
  return useMutation<{ createMinisite: TData },
      ICreateMinisiteMutationFields>(
        createMinisiteMutation(fragment), options,
      );
}
